export { SectionHeader } from './SectionHeader';
export type { SectionHeaderProps } from './SectionHeader.types';
